import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAccount, useDisconnect, useSwitchChain } from "wagmi"
import { Button } from "~/core/components/Button"
import { Modal } from "~/core/components/Modal"
import { ABS_CHAIN } from "~/core/constants"
import { useToast } from "~/core/contexts/ToastContext"

export const UnsupportedNetworkModal = () => {
  const { chainId, isConnected, isReconnecting } = useAccount()
  const { switchChainAsync } = useSwitchChain()
  const toast = useToast()
  const { connectors, disconnect } = useDisconnect()
  const navigate = useNavigate()

  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(isConnected && !isReconnecting && chainId !== ABS_CHAIN.id)
  }, [isConnected, isReconnecting, chainId])

  const onDisconnect = () => {
    disconnect()
    connectors.forEach(connector => {
      connector.disconnect()
    })
    localStorage.clear()
  }

  const onSwitch = async () => {
    try {
      await switchChainAsync({ 
        chainId: ABS_CHAIN.id, 
        addEthereumChainParameter: {
          chainName: ABS_CHAIN.name,
          nativeCurrency: ABS_CHAIN.nativeCurrency,
          rpcUrls: ABS_CHAIN.rpcUrls.default.http,
          blockExplorerUrls: [ABS_CHAIN.blockExplorers.native.url]
        } 
      }) 
    } catch (error) {
      toast.error('Failed to switch network')
    }
  }

  return (
     <Modal
      type="drawer"
      visible={visible}
    >
      <div className="flex justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 pt-6 pb-5 rounded-tl-2xl rounded-tr-2xl bg-white">
        <p className="flex-grow-0 flex-shrink-0 text-lg font-bold text-justify text-[#191d29]">
          Unsupported network
        </p>
      </div>
      <div className="flex flex-col justify-center items-center self-stretch flex-grow-0 flex-shrink-0 relative px-4 pb-1 rounded-tl-2xl rounded-tr-2xl bg-white">
        <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-center text-[#2e394b]">
          We currently only support {ABS_CHAIN.name}
        </p>
      </div>
      <div className="flex flex-col-reverse gap-3 px-5 py-4 pb-6 md:flex-row">
        <Button
          type="secondary"
          onClick={onDisconnect}
        >
          Disconnect
        </Button>
        <Button
          onClick={onSwitch}
        >
          Switch network
        </Button>
      </div>
    </Modal>
  )
}